import type { SituacaoItem } from '@triade/contracts';
import { cn } from '@/lib/utils';
import { ROTULO_SITUACAO } from './tipos';

const ESTILO: Record<SituacaoItem, string> = {
  ATIVO: 'bg-success-bg text-success-ink',
  INATIVO: 'bg-line-soft text-ink-body',
  ARQUIVADO: 'border border-border bg-card text-ink-muted',
};

/** Situacao do cadastro do item (pill; cores do design Item.dc.html: "Ativo" verde). */
export function SituacaoBadge({ situacao, className }: { situacao: SituacaoItem; className?: string }) {
  return (
    <span data-situacao={situacao} className={cn('inline-flex rounded-full px-2.5 py-0.5 text-caption font-semibold', ESTILO[situacao], className)}>
      {ROTULO_SITUACAO[situacao]}
    </span>
  );
}
